import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Box, useMediaQuery } from "@mui/material";
import Notification from "./components/notification/page";
import DataTable from "./components/datatable/page";

export default function App() {
  const isMobile = useMediaQuery("(max-width: 700px)");
  const [dataLocations, setDataLocations] = useState([]);
  const [dataSectors, setDataSectors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataFilterChanged, setIsDataFilterChanged] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const getDataLocations = async () => {
    try {
      const response = await axios.get(
        "https://www.pasarmanado.id/wp-json/pasarmanado/v1/pasar",
      );
      // console.log("res locations", response.data);
      setDataLocations(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllData = async () => {
    setIsLoading(true);
    try {
      await getDataLocations();
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsDataFilterChanged(false);
      }, 1000);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  // const setIsDataFilterChangedTrue = useCallback(() => {
  //   setIsDataFilterChanged(true);
  // }, []);

  // const setIsDataFilterChangedFalse = useCallback(() => {
  //   setIsDataFilterChanged(false);
  // }, []);

  // =========================
  // UI
  // =========================
  return (
    <Box
      id="pasarmanado-lapak-app"
      sx={{
        width: "100%",
        maxWidth: "100%",
        fontFamily: "Poppins, sans-serif",
        fontSize: "16px",
        lineHeight: 1.5,
        color: "#111827",
        boxSizing: "border-box",
        isolation: "isolate",
        "&, & *": {
          boxSizing: "border-box",
        },
        "& button, & input, & textarea, & select": {
          fontFamily: "Poppins, sans-serif",
        },
      }}
    >
      <DataTable
        dataLocations={dataLocations}
        isLoading={isLoading}
        onNotify={(notify) => setSnackbar(notify)}
        isMobile={isMobile}
      />

      {/* Snackbar notification */}
      <Notification
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </Box>
  );
}
